import { UiKit } from '@datavant/uikit';
import React, { useEffect, useState } from 'react';
import useUser from '../lib/useUser';
import { useDisclosure } from '@chakra-ui/react';
import { RingCentral } from '../forms/selfServeOnboarding/sections/RingCentral';
import { TenantTools } from '../lib/user/enums';
import {
    RM_BASIC_SUPPORT_EMAIL,
    RM_BASIC_SUPPORT_PHONE,
    SUPPORT_EMAIL,
    SUPPORT_PHONE,
} from '../lib/utils/consts';
import { useRouter } from 'next/router';
import { TutorialModal } from './RMBasic/modals/TutorialModal';

const PATHS_WITH_HELP_DROPDOWN_REGEX = {
    onboarding_setup: /\/onboarding\/setup/,
    rm_basic_upload: /\/provider\/upload\/\d+/,
};

export const RequestManagerTopNavItems = (): JSX.Element => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const currentUser = useUser();
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const [showTutorial, setShowTutorial] = useState<boolean>(false);
    const router = useRouter();

    const currentLocation = typeof window !== 'undefined' ? window.location.href : '';
    const isRmBasicUploadPage = PATHS_WITH_HELP_DROPDOWN_REGEX['rm_basic_upload'].test(currentLocation);

    const supportPhone = isRmBasicUploadPage ? RM_BASIC_SUPPORT_PHONE : SUPPORT_PHONE;
    const supportEmail = isRmBasicUploadPage ? RM_BASIC_SUPPORT_EMAIL : SUPPORT_EMAIL;

    useEffect(() => {
        const isOnboardingSetupPage = PATHS_WITH_HELP_DROPDOWN_REGEX['onboarding_setup'].test(
            currentLocation ? currentLocation : ''
        );
        const isRmUser = currentUser.user?.tenantTools?.includes(TenantTools.REQUEST_MANAGER) ?? false;
        setShowDropdown(isOnboardingSetupPage || isRmUser || isRmBasicUploadPage);
    }, [currentUser]);

    const logout = async (): Promise<void> => {
        void router.push('/provider/upload');
    };

    return showDropdown ? (
        <UiKit.Chakra.Box>
            <TutorialModal isOpen={showTutorial} onClose={() => setShowTutorial(false)} />
            <UiKit.Chakra.HStack spacing={'24px'}>
                <UiKit.Chakra.Menu isOpen={isOpen}>
                    <UiKit.Chakra.MenuButton onMouseEnter={onOpen} onMouseLeave={onClose}>
                        <UiKit.Chakra.HStack align={'end'}>
                            <UiKit.Icons.FontAwesomeIcon
                                icon={UiKit.Icons.FontAwesome.regular.faQuestionCircle}
                                color={UiKit.consistency.white}
                            />
                            <UiKit.Text.BodyRegular color={UiKit.consistency.white}>
                                Help
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.HStack>
                    </UiKit.Chakra.MenuButton>
                    <UiKit.Chakra.MenuList onMouseEnter={onOpen} onMouseLeave={onClose}>
                        <UiKit.Chakra.MenuGroup>
                            <UiKit.Chakra.VStack spacing={'0px'} align={'start'} px={'10px'}>
                                <UiKit.Text.Heading7 text={'Help'} />
                                <UiKit.Text.BodyRegular color={UiKit.consistency.gray50}>
                                    Phone: {supportPhone}
                                </UiKit.Text.BodyRegular>
                                <UiKit.Text.BodyRegular color={UiKit.consistency.gray50}>
                                    Email: {supportEmail}
                                </UiKit.Text.BodyRegular>
                                {isRmBasicUploadPage ? (
                                    <UiKit.Button.Primary
                                        text="View Tutorial"
                                        onClick={() => {
                                            setShowTutorial(true);
                                        }}
                                    />
                                ) : null}
                            </UiKit.Chakra.VStack>
                        </UiKit.Chakra.MenuGroup>
                        {isRmBasicUploadPage ? (
                            <></>
                        ) : (
                            <>
                                <UiKit.Chakra.MenuDivider />
                                <UiKit.Chakra.MenuGroup>
                                    <UiKit.Chakra.VStack spacing={'75px'} align={'end'} h="75px">
                                        <RingCentral.Button />
                                        <UiKit.Text.BodyRegular> </UiKit.Text.BodyRegular>
                                    </UiKit.Chakra.VStack>
                                </UiKit.Chakra.MenuGroup>
                            </>
                        )}
                    </UiKit.Chakra.MenuList>
                </UiKit.Chakra.Menu>
                {isRmBasicUploadPage ? (
                    <UiKit.Chakra.Box as="button" onClick={logout}>
                        <UiKit.Chakra.HStack spacing={'8px'}>
                            <UiKit.Icons.FontAwesomeIcon
                                icon={UiKit.Icons.FontAwesome.solid.faSignOut}
                                color={UiKit.consistency.white}
                            />
                            <UiKit.Text.BodyRegular color={UiKit.consistency.white}>
                                Log Out
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.HStack>
                    </UiKit.Chakra.Box>
                ) : null}
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.Box>
    ) : (
        <></>
    );
};
